import React from 'react'
import { useTranslation } from 'next-i18next/pages'
import { FOOTER_URLS } from '@components/common/Footer/footer-config'
import s from './PreFooter.module.scss'
import Chat from './icons/Chat'
import Faq from './icons/Faq'
import Store from './icons/Store'
import Track from './icons/Track'

type ZendeskCommand = (...args: unknown[]) => void

const openEvaChat = (): void => {
    const zE = (window as Window & { zE?: ZendeskCommand }).zE
    if (typeof zE !== 'function') return
    try {
        zE('messenger', 'open')
    } catch {
        zE('webWidget', 'open')
    }
}

const PreFooter = (): React.ReactElement => {
    const { t } = useTranslation('common')

    return (
        <section className={s.root} aria-label={t('footer|prefooter label')}>
            <div className={s.inner}>
                <ul className={s.list}>
                    <li className={s.item}>
                        <Chat className={s.icon} />
                        <h2 className={s.title}>
                            {t('footer|prefooter chat title')}
                        </h2>
                        <p className={s.copy}>
                            {t('footer|prefooter chat description')}
                        </p>
                        <button
                            type="button"
                            className={s.cta}
                            onClick={openEvaChat}
                        >
                            {t('footer|prefooter chat cta')}
                        </button>
                    </li>
                    <li className={s.item}>
                        <Track className={s.icon} />
                        <h2 className={s.title}>
                            {t('footer|prefooter track title')}
                        </h2>
                        <p className={s.copy}>
                            {t('footer|prefooter track description')}
                        </p>
                        <a
                            className={s.cta}
                            href={FOOTER_URLS.trackOrder}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('footer|prefooter track cta')}
                        </a>
                    </li>
                    <li className={s.item}>
                        <Faq className={s.icon} />
                        <h2 className={s.title}>
                            {t('footer|prefooter faq title')}
                        </h2>
                        <p className={s.copy}>
                            {t('footer|prefooter faq description')}
                        </p>
                        <a
                            className={s.cta}
                            href={FOOTER_URLS.helpCenter}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('footer|prefooter faq cta')}
                        </a>
                    </li>
                    <li className={s.item}>
                        <Store className={s.icon} />
                        <h2 className={s.title}>
                            {t('footer|prefooter store title')}
                        </h2>
                        <p className={s.copy}>
                            {t('footer|prefooter store description')}
                        </p>
                        <a
                            className={s.cta}
                            href={FOOTER_URLS.findStore}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('footer|prefooter store cta')}
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default PreFooter
